












































import Vue from "vue";
import Card from "./Card.vue";
import { state } from "../../data/state";
import SkeletonLoaderItem from "@/components/SkeletonLoaderItem.vue";
import { UseModal } from "@/components/root/modal";
import MassDownlodersWithPlaybookModalVue from "@/views/customize/in-motion/security-policies/mass-download/users-modal/MassDownlodersWithPlaybookModal.vue";
import { SharedState } from "@/common/state";
import { CountItem } from "../../data/model";
import InsightL0sCountModalVue from "./InsightL0sCountModal.vue";
import { ICONS } from "@/common/icons.map";
import RiskyUsersWithPlaybookModalVue from "@/views/customize/in-motion/security-policies/risky-users/top-risky-users-modal/RiskyUsersWithPlaybookModal.vue";
import EventsModalVue from "@/components/modals/events-modal/EventsModal.vue";
import { EventsModalProps } from "@/components/modals/events-modal/model";
import { AxisType, CoordinateInputTier3 } from "@/gql/types";
import AskForJustificationPolicyScriptModalVue from "@/views/customize/in-motion/security-policies/ask-for-justification/AskForJustificationPolicyScriptModal.vue";
export default Vue.extend({
  components: { Card, SkeletonLoaderItem },
  setup() {
    const {
      source_security_insights,
      is_loading_all,
      selected_from_time_frame,
    } = state;

    const show_l0_counts_modal = async (data: {
      title: string;
      type: "risk_users" | "mass_downloads" | "event_justification";
      counts: CountItem[];
    }) => {
      const res = await UseModal().show(InsightL0sCountModalVue, {
        title: data.title,
        items: data.counts.map((d) => {
          return {
            ...d,
            icon: ICONS.L0_ICONS.get(
              SharedState.allInfoTypes.value[d.id]!.code
            ),
          };
        }),
      });
      if (res.type == "success") {
        const premium_key = {
          risk_users: "topriskyusers-popup-2024",
          mass_downloads: "massdownloads-popup-2024",
          event_justification: "highseverityrisk-popup-2024",
        };
        SharedState.ifIsPayingUser(
          async () => {
            //@ts-ignore
            const item: CountItem = res.msg;
            const label = SharedState.allInfoTypes.value[item.id];
            if (SharedState.restrictions.is_restricted_info(label.code)) {
              SharedState.restrictions.show_restrictions_modal(
                "info",
                label.labelName
              );
              return;
            }

            switch (data.type) {
              case "risk_users":
                await UseModal().show(RiskyUsersWithPlaybookModalVue, {
                  name: item.name,
                  id: item.id,
                });
                break;
              case "mass_downloads":
                await UseModal().show(MassDownlodersWithPlaybookModalVue, {
                  name: item.name,
                  id: item.id,
                });
                break;
              case "event_justification":
              default:
                const res = await UseModal().show(EventsModalVue, {
                  title: `<b>High severity</b> Events including <b>${item.name}</b> information`,
                  events_only: true,
                  playbook: {
                    text: `<b>Automatically</b> send emails requesting a <b>user justification</b> On any <b>high severity event</b> which involves <b>${item.name}</b> information`,
                    cta: "Show Playbook",
                  },
                  hide_filters: ["severities"],
                  coordinates: [
                    {
                      x: {
                        type: AxisType.ContentLabel,
                        values: [item.id],
                      },
                      y: {
                        type: AxisType.Severity,
                        values: ["3"],
                      },
                      z: {
                        type: selected_from_time_frame.value?.type,
                        values: [selected_from_time_frame.value?.value],
                      },
                    },
                  ] as CoordinateInputTier3[],
                } as EventsModalProps);
                if (res.type == "success" && res.msg == "playbook") {
                  UseModal().show(AskForJustificationPolicyScriptModalVue, {
                    label_id: item.id,
                    label_name: item.name,
                  });
                }
                break;
            }
          },
          { premium_modal_key: premium_key[data.type] }
        );
      }
    };

    return {
      source_security_insights,
      is_loading_all,
      show_l0_counts_modal,
    };
  },
});
